var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVinJourneyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 13.75C15.1875 14.7165 14.404 15.5 13.4375 15.5C12.471 15.5 11.6875 14.7165 11.6875 13.75M15.1875 13.75C15.1875 12.7835 14.404 12 13.4375 12C12.471 12 11.6875 12.7835 11.6875 13.75M15.1875 13.75H17.8125M11.6875 13.75H10.8125M10.8125 13.75H6.4375M10.8125 13.75V4.3C10.8125 3.31991 10.8125 2.82986 10.6217 2.45552C10.454 2.12623 10.1863 1.85851 9.857 1.69074C9.48267 1.5 8.99259 1.5 8.0125 1.5H3.9875C3.00741 1.5 2.51736 1.5 2.14302 1.69074C1.81373 1.85851 1.54601 2.12623 1.37824 2.45552C1.1875 2.82986 1.1875 3.31991 1.1875 4.3V12C1.1875 12.9665 1.971 13.75 2.9375 13.75M10.8125 13.75V5H14.3125L16.9375 8.5M6.4375 13.75C6.4375 14.7165 5.654 15.5 4.6875 15.5C3.721 15.5 2.9375 14.7165 2.9375 13.75M6.4375 13.75C6.4375 12.7835 5.654 12 4.6875 12C3.721 12 2.9375 12.7835 2.9375 13.75M16.9375 8.5V13.75M16.9375 8.5H10.8125",
    stroke: "#1C1B1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinJourneyIcon);
export default __webpack_public_path__ + "static/media/vin_journey_icon.c82ce029b798c355ade7288e6d532d4d.svg";
export { ForwardRef as ReactComponent };